<template>
  <div>
    <news-letter-form @submit="createPost"
                      :loading="loading">
    </news-letter-form>
  </div>
</template>
<script>
  import NewsLetterForm from './NewsLetterForm'
  import NewsLetterService from 'src/services/NewsLetterService'
  export default {
    name: 'news-letter-create',
    components: {
      NewsLetterForm
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async createPost(post) {
        try {
          this.loading = true
          await NewsLetterService.create(post)
          this.$router.push('/content/newsletter')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    }
  }
</script>
<style>
</style>
